<template>
  <div class="swiper">
    <el-carousel
      trigger="click"
      :interval="6000"
      arrow="never"
      @change="changeIndex"
    >
      <el-carousel-item v-for="(item, index) in dataList" :key="index">
        <div class="swiper-box">
          <img :class="['image', {scale: actived == index }]" :src="JSON.parse(item.adv_pic)[0].url">
          <!-- <section class="callout" v-if="index == 0">
            <div :class="['content', {textAnimated: actived == index}]">
              <div class="title">
                科技创美生活
              </div>
              <div class="descr">
                <p>健康 自然 绿色</p>
                <p>打造家居健康美学</p>
                <p>筑造理想环保居所</p>
              </div>
            </div>
          </section> -->
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: 'swiper',
  props: {
      dataList: {
        default: [],
        type: Array
      }
    },
  data() {
    return {
      swpierList: [
        // {
        //   image: require('../assets/index/banner1.jpg'),
        // },
       ` {
          image: require('../assets/index/banner2.jpg'),
        },
        {
          image: require('../assets/index/banner.png'),
        }`
      ],
      actived: 0
    }
  },
  mounted() {

  },
  methods: {
    changeIndex(index) {
      this.actived = index
    }
  }
}
</script>

<style lang="less" scoped>
.swiper {
  width: 100%;
  max-width: 1920px;
  max-height: 926px;
  margin: 0 auto;
  .swiper-box {
    width: 100%;
    height: 100%;
    max-width: 1920px;
    max-height: 926px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      vertical-align: middle;
    }
    .scale {
      animation: imageScale 2s forwards;
    }
    .content {
      width: 100%;
      text-align: center;
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title {
        font-size: 48px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 25px;
        margin-bottom: 32px;
      }
      .descr {
        font-size: 28px;
        color: #FFFFFF;
        line-height: 36px;
        margin: 0 auto;
        p {
          margin: 0;
        }
      }
    }
    // .content.textAnimated {
    //   // animation: textFadeupin  1.6s forwards;
    // }
  }
  /deep/ .el-carousel__container {
    height: 926px;
    max-height: 926px;
  }
  /deep/ .el-carousel__indicators {
    bottom: 37px;
  }
  /deep/ .el-carousel__button {
    width: 68px;
    height: 8px;
    background: #fff;
  }
  /deep/ .el-carousel__indicator.is-active {
    .el-carousel__button{
      background: #009538
    }
  }
}
</style>
<style>
@keyframes imageScale {
  0% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes textFadeupin {
  0% {
    transform: translateY(50px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>